import ShieldIcon from "@mui/icons-material/Shield";
import LinkIcon from "@mui/icons-material/Link";
import HistoryIcon from "@mui/icons-material/History";
import type { SvgIconComponent } from "@mui/icons-material";

export interface DashboardInfoCardSpec {
  i18nKey: string;
  icon: SvgIconComponent;
  color: string;
  bg: string;
  darkBg: string;
}

export const DASHBOARD_INFO_CARDS: DashboardInfoCardSpec[] = [
  {
    i18nKey: "info.privacy",
    icon: ShieldIcon,
    color: "#F97316",
    bg: "#FFF7ED",
    darkBg: "#431407",
  },
  {
    i18nKey: "info.sharing",
    icon: LinkIcon,
    color: "#8B5CF6",
    bg: "#F5F3FF",
    darkBg: "#2E1065",
  },
  {
    i18nKey: "info.expiry",
    icon: HistoryIcon,
    color: "#10B981",
    bg: "#ECFDF5",
    darkBg: "#022C22",
  },
];
